import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { fromStoreQueryToStore } from '../../adapters/from-store-query-to-store.js';
import { GET_BOOK_APPOINTMENT_STORE } from '../../queries/get-book-appointment-store.js';

const useBookAppointmentStore = ({ isTryInStoreFlowEnabled =false  } = {})=>{
    const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_STORE);
    const { locale  } = useIntl();
    if (queryState.error) {
        console.error(queryState.error);
    }
    const getBookAppointmentStore = React.useCallback((code)=>query(swcHelpers.objectSpread({
            variables: {
                code
            }
        }, locale ? {
            context: {
                forwardHeaders: {
                    'Accept-Language': locale
                }
            }
        } : {}))
    , [
        query,
        locale
    ]);
    const data = React.useMemo(()=>{
        var ref;
        return fromStoreQueryToStore((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store, [
            {
                tryInStore: isTryInStoreFlowEnabled
            }
        ]);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            getBookAppointmentStore,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getBookAppointmentStore,
        queryState,
        data
    ]);
};

export { useBookAppointmentStore as default };
//# sourceMappingURL=use-book-appointment-store.js.map
